import React from "react";
import { FaArrowRightLong } from "react-icons/fa6";
import { Link } from "react-router-dom";

const VideoCard = ({ item }) => {
  return (
    <Link to={`/qs-academy/course/details/${item?.id}`} className="flex flex-col gap-4 w-full bg-[#143b51] rounded-md">
      <img
        src={`${import.meta.env.VITE_API_BASE_URL}/storage/${item.image}`}
        alt={item.name}
        className="w-full h-[20rem] object-cover rounded-t-md"
      />
      <div className="flex flex-col gap-2 p-4">
        <h2 className="text-xl font-medium text-[#bfbfbf] truncate">
          {item?.name}
        </h2>
        <h3 className="text-base font-medium text-[#bfbfbf] truncate">
          {item?.author_name}
        </h3>
        <div className="flex items-center gap-2">
          <span className="text-xl font-bold text-[#bfbfbf]">
            ৳{item?.current_price}
             </span>
          <span className="text-[#22BEFF] text-base">
            <del>৳{item?.regular_price}</del>
          </span>
        </div>
        <span className="flex items-center gap-2 text-sm text-[#22BEFF] cursor-pointer">
          বিস্তারিত <FaArrowRightLong />
        </span>
      </div>
    </Link>
  );
};

export default VideoCard;
